import { QuizQuestion } from "components/global/QuizQuestion/QuizQuestion";
import { useState } from "react";
import Styles from './QuizView.module.scss'
import { QuizButton } from '../../../Labs/LabQuiz/LabQuiz';


export function QuizView({ data, setQuiz, onFinish }) {
    const [startQuiz, setStartQuiz] = useState(false);
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [selectedAnswers, setSelectedAnswers] = useState([]);
    const [isResults, setIsResults] = useState(false);
    const [score, setScore] = useState({
        percent: '',
        mark: ''
    })

    const handleSelect = (orderId, questId, selectedOption, question) => {
        setSelectedAnswers((prevSelectedAnswers) => {
            const updatedSelectedAnswers = [...prevSelectedAnswers];

            updatedSelectedAnswers[orderId] = {
                question: data?.questions[currentQuestion]?.question,
                options: data?.questions[currentQuestion]?.options,
                answer: data?.questions[currentQuestion]?.answer,
                question_id: questId,
                selectedOption: selectedOption,
            };

            return updatedSelectedAnswers;
        });
    }
    const handlePrevClick = () => {
        setCurrentQuestion(currentQuestion - 1);
    }
    const handleNextClick = () => {
        setCurrentQuestion(currentQuestion + 1);

    }
    const handleSubmit = () => {
        if (isResults) {
            const result = {
                quizName: data?.quizName,
                score: score
            }
            setQuiz((previousItems) => {
                const existingIndex = previousItems.quiz.findIndex(
                    (item) => item.quizName === result.quizName
                );
                if (existingIndex !== -1) {
                    return {
                        ...previousItems,
                        quiz: [
                            ...previousItems.quiz.slice(0, existingIndex),
                            result,
                            ...previousItems.quiz.slice(existingIndex + 1),
                        ],
                    };
                } else {
                    return {
                        ...previousItems,
                        quiz: [...previousItems.quiz, result],
                    };
                }

            })
            onFinish();
            return;
        }
        const answerEvaluation = selectedAnswers?.filter((ans) => {
            if (ans.selectedOption === ans?.answer) {
                ans.isAttempted = true;
                ans.isCorrect = true;
            } else {
                ans.isAttempted = true;
                ans.isCorrect = false;
            }
            return ans;
        })
        const correctAnswers = answerEvaluation.filter(ans => ans.isCorrect === true);
        const percent = ((correctAnswers?.length / data?.questions?.length) * 100);
        setScore({
            percent: Math.ceil(percent),
            mark: correctAnswers?.length
        });
        setCurrentQuestion(0);
        setIsResults(true)
    }
    return (
        <div className={Styles.main_container}>
            {
                !startQuiz ?
                    <div className={Styles.headingContainer}>
                        <p className={Styles.quizHeading}>{data?.quizName?.toUpperCase()}</p>
                        <QuizButton
                            onClick={() => { setStartQuiz(true) }}
                            // condition={currentQuestion === 0}
                            buttonText={'START'}
                            showIcon={false}
                            showResult={false}
                        ></QuizButton>
                    </div>
                    :
                    <>
                        {isResults && <p style={{ color: "black", fontWeight: 600 }}>Correct Answers: {score.mark} | Score: {score.percent}%</p>}
                        <div className={Styles.QuizQuestionContainer}>
                            <QuizQuestion
                                key={!isResults ? data?.questions[currentQuestion] : selectedAnswers[currentQuestion]}
                                question={!isResults ? data?.questions[currentQuestion] : selectedAnswers[currentQuestion]}
                                questionNumber={currentQuestion + 1}
                                onAnswerSelect={handleSelect}
                                selectedAnswers={selectedAnswers}
                                Results={isResults}
                            />
                        </div>
                        <div className={Styles.buttonContainer}>
                            <span>
                                <QuizButton
                                    onClick={handlePrevClick}
                                    condition={currentQuestion === 0}
                                    buttonText={'Prev'}
                                    showIcon={false}
                                    showResult={false}
                                ></QuizButton>
                            </span>
                            <span>
                                <QuizButton
                                    onClick={handleNextClick}
                                    condition={currentQuestion === data?.questions?.length - 1}
                                    buttonText={'Next'}
                                    showIcon={false}
                                    showResult={false}
                                ></QuizButton>
                            </span>
                            <span>
                                <QuizButton
                                    onClick={handleSubmit}
                                    condition={selectedAnswers?.length !== data?.questions?.length}
                                    buttonText={isResults ? 'Finish' : 'Submit'}
                                    showIcon={!isResults}
                                    showResult={isResults}
                                ></QuizButton>
                            </span>
                        </div>
                    </>
            }


        </div>
    )
}
